<script>
  import { router, page } from '@inertiajs/svelte'
  import FilterField from './filter_field.svelte'
  import Icon from './ui/icon.svelte'

  let {
    value = $bindable(''),
    param = 'search',
    placeholder = 'Search…',
    label = 'Search',
    debounceMs = 350
  } = $props()

  let timeoutId = null

  // Starting or clearing a search adds a history entry, so Back returns to the unsearched list;
  // refining one already in the URL replaces it (one entry per debounced keystroke would pile up).
  const commit = () => {
    const url = new URL($page.url, 'http://placeholder')
    const replace = !!url.searchParams.get(param) && !!value
    if (value) {
      url.searchParams.set(param, value)
    } else {
      url.searchParams.delete(param)
    }
    url.searchParams.delete('page')
    router.get(`${url.pathname}${url.search}`, {}, { preserveState: true, preserveScroll: true, replace })
  }

  const oninput = () => {
    if (timeoutId) clearTimeout(timeoutId)
    timeoutId = setTimeout(commit, debounceMs)
  }

  const clear = () => {
    if (timeoutId) clearTimeout(timeoutId)
    value = ''
    commit()
  }
</script>

<FilterField {label}>
  <div class="relative">
    <input
      type="search"
      bind:value
      {oninput}
      {placeholder}
      class="input input-sm w-48 pr-7 [&::-webkit-search-cancel-button]:hidden"
      aria-label={label || placeholder}
    />
    {#if value}
      <button
        type="button"
        class="absolute right-1.5 top-1/2 -translate-y-1/2 text-base-content/40 hover:text-base-content cursor-pointer"
        aria-label="Clear search"
        onclick={clear}
      >
        <Icon name="close" size="xs" />
      </button>
    {/if}
  </div>
</FilterField>
